<template>
  <div>
    <a-modal
      title="Please Enter Vessel Info"
      :visible="modal_vessel_visible"
      @ok="submit_create"
      @cancel="modal_vessel_visible = false"
    >
      <a-form>
        <a-form-item label="Vessel Name:">
          <a-input v-model="vsl.vessel_name" />
          <a-button type="primary" @click="search_for_shipID">Search For ShipID</a-button>
        </a-form-item>

        <a-form-item label="Ship ID:">
          <a-select v-model="vsl.shipid">
            <a-select-option v-for="s in shipIDs" :key="s.ShipID" :value="s.ShipID"
              >Name:{{ s.name }} --- CALLSIGN:{{ s.callsign }}--- ID:{{
                s.ShipID
              }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item label="Ship Type:">
          <a-select v-model="vsl.contract_type">
            <a-select-option value="VC">VC</a-select-option>
            <a-select-option value="TC">TC</a-select-option>
            <a-select-option value="TCT">TCT</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="CP Date:">
          <a-date-picker v-model="vsl.cpdate" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- <a-card
      title="Total Income"
      style="width: 300px; display: inline-block; margin-right: 30px; margin-bottom: 30px"
    >
      <h1>{{ TI }}</h1>
    </a-card>
    <a-card
      title="Total Payout"
      style="width: 300px; margin-right: 30px; display: inline-block"
    >
      <h1>{{ TP }}</h1>
    </a-card>
    <a-card title="Net" style="width: 300px; display: inline-block">
      <h1>{{ NET }}</h1>
    </a-card> -->

    <a-button
      :style="{ marginBottom: '30px', display: 'block' }"
      type="primary"
      @click="modal_vessel_visible = true"
      >Create Vessel</a-button
    >

    <a-table
      size="small"
      :dataSource="table_data"
      :columns="columns"
      rowKey="id"
      :pagination="{ defaultPageSize: 50 }"
      align="center"
    >
      <!-- text search  the variables name for slot-scope is fixed and change of which will cause malfunctioning-->
      <div
        slot="text_filter"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-input
          v-ant-ref="(c) => (text_search_input = c)"
          :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]"
          @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm)"
          style="width: 188px; margin-bottom: 8px; display: block"
        />
        <a-button
          type="primary"
          @click="() => handleSearch(selectedKeys, confirm)"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          >Search</a-button
        >
        <a-button
          @click="() => handleReset(clearFilters)"
          size="small"
          style="width: 90px"
          >Reset</a-button
        >
      </div>

      <!-- date range search -->
      <div
        slot="date_filter"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters }"
        style="padding: 8px"
      >
        <a-range-picker
          size="small"
          style="width: 200px; margin-bottom: 8px; display: block"
          v-ant-ref="(c) => (date_range_input = c)"
          v-model="search_date_range"
          @change="setSelectedKeys(search_date_range)"
        />
        <a-button
          @click="handle_date_range_search(search_date_range, confirm)"
          type="primary"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          >Search</a-button
        >
        <a-button @click="clearFilters" size="small" style="width: 90px; margin-left: 8px"
          >Reset</a-button
        >
      </div>

      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />

      <!-- Data Display and Data Change -->
      <template
        v-for="col in ['vessel_name', 'cpdate']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <template v-if="record.editable">
            <a-date-picker
              v-if="col == 'cpdate'"
              v-model="record.cpdate_obj"
              @change="(e) => change_data(e, record, col)"
            />
            <a-input
              v-if="col == 'vessel_name'"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => change_data(e.target.value, record, col)"
            />
          </template>
          <template v-else>
            <div v-if="col == 'vessel_name'">
              <router-link tag="a" :to="'/transactions/' + record.id">{{
                text
              }}</router-link>
            </div>
            <div v-else>{{ text }}</div>
          </template>
        </div>
      </template>

      <template slot="net" slot-scope="text">
        <div v-if="text.substr(0, 1) == '-'" style="color: red">{{ text }}</div>
        <div v-else style="color: green">{{ text }}</div>
      </template>

      <!-- operation -->
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-popconfirm title="About to Save?" @confirm="() => save(record.id)">
              <a>Save</a>
            </a-popconfirm>

            <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.id)">
              <a>Cancel</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a @click="() => edit(record.id)">Edit</a>

            <a-popconfirm
              title="Sure to Delete?"
              @confirm="() => delete_record(record.id)"
            >
              <a>Delete</a>
            </a-popconfirm>

            <router-link tag="a" :to="'/map/' + record.shipid">Position</router-link>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    // ES7 deep copy syntax ... will interate and deep copy an object's prop or element of array
    this.cacheData = [];
    return {
      vsl: {
        vessel_name: "",
        cpdate: moment(),
        contract_type: "TC",
        shipid: "",
        sync: false,
      },

      shipIDs: [],
      TI: 0,
      TP: 0,
      NET: 0,

      modal_vessel_visible: false,

      table_data: [],

      searchText: "",

      text_search_input: null,

      search_date_range: [],
      date_range_input: null,

      columns: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
          align: "center",
          sorter: (a, b) => Number.parseInt(a.id) - Number.parseInt(b.id),
        },
        {
          title: "Vessel REF",
          dataIndex: "veseel_ref",
          key: "veseel_ref",
          align: "center",
          scopedSlots: {
            filterDropdown: "text_filter",
            filterIcon: "filterIcon",
            customRender: "veseel_ref",
          },
          onFilter: (value, record) =>
            record.veseel_ref.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.text_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Name",
          dataIndex: "vessel_name",
          key: "vessel_name",
          align: "center",
          sorter: (a, b) => a.vessel_name.localeCompare(b.vessel_name),
          scopedSlots: {
            filterDropdown: "text_filter",
            filterIcon: "filterIcon",
            customRender: "vessel_name",
          },
          onFilter: (value, record) =>
            record.vessel_name.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.text_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Ship Query ID",
          dataIndex: "shipid",
          key: "shipid",
          align: "center",
        },
        {
          title: "Date",
          dataIndex: "cpdate",
          key: "cpdate",
          align: "center",
          scopedSlots: {
            filterDropdown: "date_filter",
            filterIcon: "filterIcon",
            customRender: "cpdate",
          },
          onFilter: (value, record) => {
            var date = moment(record.cpdate).set({
              hour: 12,
              minute: 0,
              second: 0,
            });
            var start = this.search_date_range[0].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            var end = this.search_date_range[1].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            if (date.isBetween(start, end, "day", "[]")) {
              return true;
            } else {
              return false;
            }
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.date_range_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Income",
          dataIndex: "total_income",
          key: "total_income",
          align: "center",
        },
        {
          title: "Payout",
          dataIndex: "total_payout",
          key: "total_payout",
          align: "center",
        },
        {
          title: "Net",
          dataIndex: "net",
          key: "net",
          align: "center",
          scopedSlots: { customRender: "net" },
        },
        {
          title: "operation",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          align: "center",
        },
      ],
    };
  },
  methods: {
    refresh() {
      //
      this.vsl = {
        vessel_name: "",
        cpdate: moment(),
        contract_type: "TC",
        shipid: "",
        sync: false,
      };
      (this.TI = 0), (this.TP = 0), (this.NET = 0), (this.shipIDs = []);
      this.$http.post(this.$store.state.base_url + "/vessel/r", {}).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          data.forEach((d) => {
            d.veseel_ref = "MV" + (d.id + 10000 + "").substr(1, 4);
            d.cpdate_obj = moment(d.cpdate);
            d.total_income = "---";
            d.total_payout = "---";
            d.net = "---";
            // d.sync = d.ship.sync ? "Y" : "N";
          });

          // set cacheData and table_data
          this.cacheData = data.map((item) => ({ ...item }));
          this.table_data = data;

          //  sum income by vessel
          this.$http.post(this.$store.state.base_url + "/income/r", {}).then((res) => {
            if (res.data.status == 1) {
              var income = res.data.data;
              this.table_data.forEach((v) => {
                var i_arr = income.filter((i) => {
                  return i.vessel_id == v.id;
                });
                var sum = 0;
                i_arr.forEach((ic) => {
                  sum = sum + Number.parseFloat(ic.amount);
                });
                v.total_income = Number.parseFloat(sum.toFixed(2));
                this.TI = this.TI + v.total_income;
              });
            }
            this.cacheData = this.table_data.map((item) => ({ ...item }));
            // sum payout by vessel
            this.$http.post(this.$store.state.base_url + "/payout/r", {}).then((res) => {
              if (res.data.status == 1) {
                var payout = res.data.data;
                this.table_data.forEach((v) => {
                  var p_arr = payout.filter((p) => {
                    return p.vessel_id == v.id;
                  });
                  var sum = 0;
                  p_arr.forEach((py) => {
                    sum = sum + Number.parseFloat(py.amount);
                  });
                  v.total_payout = Number.parseFloat(sum.toFixed(2));
                  this.TP = this.TP + v.total_payout;
                  v.net = (v.total_income - v.total_payout).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  });
                  v.total_payout = v.total_payout.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  });
                  v.total_income = v.total_income.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  });
                });
              }
              this.NET = (this.TI - this.TP).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });
              this.TI = this.TI.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });
              this.TP = this.TP.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });

              this.cacheData = this.table_data.map((item) => ({ ...item }));
            });
          });
        }
      });
    },

    //  table search function
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    handle_date_range_search(selected_range, confirm) {
      confirm();
    },

    // table edit function
    edit(key) {
      // deep copy ES7 syntax
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.table_data = newData;
      }
    },

    change_data(value, record, col) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => record.id === item.id)[0];
      if (col == "cpdate") {
        target[col] = value.format("YYYY-MM-DD");
      } else {
        target[col] = value;
      }
      this.table_data = newData;
    },

    // Veseel Operation Function
    save(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];

      // net work operation hare
      // success and fails
      console.log("Save to Server");
      var d = {
        id: target.id,
        vessel_name: target.vessel_name,
        cpdate: target.cpdate,
        sync: target.sync == "Y" ? "true" : "false",
      };
      this.$http.post(this.$store.state.base_url + "/vessel/u", d).then((res) => {
        if (res.data.status == 1) {
          this.$message.info(res.data.msg);
          delete target.editable;
          this.table_data = newData;
          this.cacheData = newData.map((item) => ({ ...item }));
        }
      });
    },
    cancel(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      // restore original data
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.id)[0]);
        delete target.editable;
        this.table_data = newData;
      }
    },

    submit_create() {
      var v = {};
      v.vessel_name = this.vsl.vessel_name;
      if (this.vsl.shipid !== "") {
        v.shipid = this.vsl.shipid;
      }
      v.cpdate = this.vsl.cpdate.format("YYYY-MM-DD");
      v.sync = this.vsl.sync;
      v.contract_type = this.vsl.contract_type;
      this.$http.post(this.$store.state.base_url + "/vessel/c", v).then((res) => {
        if (res.data.status == 1) {
          this.modal_vessel_visible = false;
          this.refresh();
        }
      });
    },
    search_for_shipID() {
      this.$http
        .get(this.$store.state.ship_url + "/QueryShip", {
          params: {
            v: this.$store.state.ship_url_v,
            k: this.$store.state.ship_url_k,
            enc: "1",
            kw: this.vsl.vessel_name,
          },
        })
        .then((res) => {
          if (res.data.status == 0) {
            this.shipIDs = res.data.data;
          }
        });
    },
    delete_record(id) {
      this.$http
        .post(this.$store.state.base_url + "/vessel/d", { id: id })
        .then((res) => {
          if (res.data.status == 1) {
            var index = this.table_data.findIndex((e) => {
              return e.id == id;
            });

            // delete and update data
            var newData = [...this.table_data];
            newData.splice(index, 1);
            this.table_data = newData;
            this.cacheData = newData.map((item) => ({ ...item }));
          }
        });
    },
  },

  mounted() {
    this.refresh();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.ant-carousel {
  margin-bottom: 30px;
}

.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #1890ff;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h1 {
  color: #fff;
}
</style>
